<template>
  <div class="price-search">
    <van-search v-model="value" placeholder="请输入关键词搜索" @search="onSearch" :clearable="false">
      <template #left-icon>
        <img src="@/assets/imgs/搜索1.png" alt="" style="display: none" />
      </template>
      <template #right-icon>
        <van-icon name="search" size="20px" @click="onSearch" />
      </template>
    </van-search>
  </div>
</template>

<script>
export default {
  name: "PriceSearch",
  components: {},
  props: {
    filterIconFlag: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {
      value: "",
    };
  },
  methods: {
    onSearch() {
      this.$emit("onSearch", this.value);
    },
    onFliter() {
      this.$emit("onFliter");
    },
  },
};
</script>

<style lang="stylus" scoped>
.price-search {
  padding: 0px 32px 32px;

  >>> .van-search {
    height: 72px;
    background: rgba(255,255,255,0.8);
    border-radius: 36px 36px 36px 36px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 14px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  >>> .van-search__content {
    background: transparent;
  }

  >>> .van-field__control {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #999999;
  }

  >>> .van-field__right-icon {
    img {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
